/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { abastecimentosModuleName } from "../shared/data.service";
import { bombasModuleName } from "../bombas/shared/data.service";
import { locaisModuleName } from "../locais/shared/data.service";
import { combustiveisModuleName } from "../combustiveis/shared/data.service";
import { BombaNavigationService } from "../bombas/shared/bomba-navigation.service";
import { CombustivelNavigationService } from "../combustiveis/shared/combustivel-navigation.service";
import { LocalNavigationService } from "../locais/shared/local-navigation.service";
import { tanquesModuleName } from "../tanques/shared/data.service";
import { TanqueNavigationService } from "../tanques/shared/tanque-navigation.service";
import { tipoAjustesModuleName } from "../tipo-ajustes/shared/data.service";
import { TipoAjusteNavigationService } from "../tipo-ajustes/shared/tipo-ajuste-navigation.service";
import {configuracaoModuleName} from "../../shared/services/data.service";

@Component({
    template: require('./abastecimento-configuracao.component.html'),
    styles: [require('./abastecimento-configuracao.component.css')]
})
export class AbastecimentoConfiguracaoComponent implements OnInit {
    module: any = abastecimentosModuleName;
    bombaModule: any = bombasModuleName;
    tanqueModule: any = tanquesModuleName;
    localModule: any = locaisModuleName;
    combustivelModule: any = combustiveisModuleName;
    tipoAjusteModule: any = tipoAjustesModuleName;
    configuracaoModule: any = configuracaoModuleName;

    constructor(
        private _bombaService: BombaNavigationService,
        private _combustivelService: CombustivelNavigationService,
        private _localService: LocalNavigationService,
        private _tanqueService: TanqueNavigationService,
        private _tipoAjusteService: TipoAjusteNavigationService
    ) { }

    ngOnInit() {
    }

    clickItem(module: any) {
        if (module.plural === this.bombaModule.plural) {
            this._bombaService.goToList();
        } else if (module.plural === this.tanqueModule.plural) {
            this._tanqueService.goToList();
        } else if (module.plural === this.localModule.plural) {
            this._localService.goToList();
        } else if (module.plural === this.combustivelModule.plural) {
            this._combustivelService.goToList();
        } else if (module.plural === this.tipoAjusteModule.plural) {
            this._tipoAjusteService.goToList();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/configuracao/abastecimento-configuracao.component.ts
 **/